import AICatalogComp from "../../components/AICatalog/index";

const AICatalogPage = () => <AICatalogComp />;

export default AICatalogPage;
